import type { FunctionalComponent } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { route } from 'preact-router';
import { Footer } from '@/components/footer.tsx';
import { NavBack } from '@/components/nav-back.tsx';
import { askAlert } from '@/store/dialog.ts';
import { useAppDispatch } from '@/store/hooks.ts';
import type { PageProps } from '@/types/props.ts';

/**
 * 이벤트 코드 입력 (시안 info4.html).
 *
 * 추가정보 3단계와 같은 파일 묶음이지만 별도 화면이다. 단계 표시가 없고
 * 헤더 제목과 액션 문구가 다르다.
 *
 * ★ 시안에도 `// TODO: 이벤트 코드 검증 연동` 만 있고 백엔드가 없다.
 *   어느 시안 페이지도 이 화면으로 링크하지 않는다. 검증 API 가 정해지면
 *   handleSubmit 을 연결한다.
 */
const InfoCode: FunctionalComponent<PageProps> = () => {
  const dispatch = useAppDispatch();
  const returnTo = useRef('/');
  const [code, setCode] = useState('');

  useEffect(() => {
    const raw = new URLSearchParams(window.location.search).get('r');
    returnTo.current = raw?.startsWith('/') && !raw.startsWith('//') ? raw : '/';
  }, []);

  async function handleSubmit() {
    if (!code) return;
    // TODO: 이벤트 코드 검증 API 연동
    await dispatch(askAlert('이벤트 코드 확인 기능은 준비 중입니다.'));
  }

  return (
    <div class="page page--add-info">
      <header class="title">
        <NavBack onBack={() => route(returnTo.current)} />
        <span class="nav-title">이벤트 코드 입력</span>
      </header>

      <main class="add-info-main">
        <div class="add-info-body">
          <h1 class="add-info-title">
            이벤트 코드가 있으신가요?
            <br />
            입력하고 추가 혜택을 받아보세요
          </h1>

          <div class="form-row">
            <div class="input-wrap">
              <input
                class="form-input form-input--code"
                type="text"
                maxLength={20}
                placeholder="이벤트 코드 입력 (선택)"
                value={code}
                onInput={(e) => setCode(e.currentTarget.value)}
              />
            </div>
          </div>
        </div>

        <div class="add-info-actions">
          <button type="button" class="btn-submit" disabled={!code} onClick={handleSubmit}>
            확인
          </button>
          <button type="button" class="btn-later" onClick={() => route(returnTo.current)}>
            건너뛰기
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default InfoCode;
